import React, { useEffect, useState } from 'react';
//import FormInput from '../../global/FormInput';
import { checkedLogo } from '../../../assets/images/formAfterSignUp';
import partnerIcon from '../../../assets/images/formAfterSignUp/partnerIcon.svg';
import Button from '../../global/Button';
import BusinessUploadForm from './BusinessUploadForm';
import { TStep4Info, TStep6Info } from '../../../types';

import './businessRegistration.css';
import { registerNetcoreActivity } from '../../../utils/registerActivity';
import ReactGA from 'react-ga4';
import jwtDecode from 'jwt-decode';

type TProps = {
  setStep: React.Dispatch<React.SetStateAction<number>>;
  step4Partners_: TStep4Info[];
  step4Info: TStep4Info;
  step6Info: TStep6Info[];
  setStep6Info: React.Dispatch<React.SetStateAction<TStep6Info[]>>;
};
const BusinessDocumentUpload = ({
  setStep,
  step4Info,
  step4Partners_,
  setStep6Info,
  step6Info,
}: TProps) => {
  const step4Partners = step4Partners_.map((partner) => partner.firstName + ' ' + partner.lastName);
  const ownersName = step4Info.firstName + ' ' + step4Info.lastName;
  const [active, setActive] = useState(1);

  const [isDisabled, setIsDisabled] = useState(false);
  const token: any = localStorage.getItem('login-token');
  const details: any = jwtDecode(token);

  useEffect(() => {
    for (let i = 0; i < step6Info.length; i++) {
      if (
        !step6Info[i].idCard?.name ||
        !step6Info[i].passport?.name ||
        !step6Info[i].proofOfAddress?.name ||
        !step6Info[i].signature?.name
      ) {
        setIsDisabled(true);
        break;
      } else {
        setIsDisabled(false);
      }
    }
  }, [step6Info]);

  return (
    <>
      {/* <FormProvider {...methods}> */}
      <form className='stepSix formCont  w-[700px] mx-auto'>
        <div className='flex justify-center md:w-full  lg:w-[700px] mx-auto'>
          <div className='w-full'>
            <div className='flex mb-[27px] gap-[10px] '>
              <div className=' border whitespace-nowrap rounded-sm !border-[#F8B400] space-x-2 py-[8px] flex items-center px-[12px] '>
                <img src={checkedLogo} alt='checkedLogo' />
                <h4 className='whitespace-nowrap'>Primary owner</h4>
              </div>
              <div className='bg-[#7683961F] py-[8px] whitespace-nowrap  space-x-2  flex items-center px-[12px]'>
                <img src={partnerIcon} alt='partnerIcon' />
                <h4 className='whitespace-nowrap'>{ownersName}</h4>
              </div>
            </div>
            <BusinessUploadForm
              index_={0}
              info={step6Info[0]}
              setInfo={setStep6Info}
              data={step6Info}
            />
          </div>
        </div>

        <div className='flex justify-center'>
          <hr className='w-[80%] my-5' />
        </div>

        {/* PARTNERS */}

        {step4Partners_?.length > 0 && (
          <div className='flex justify-center md:w-full  lg:w-[800px] mx-auto'>
            <div className='w-full'>
              <div className='flex mb-[27px] gap-[10px] '>
                <div className=' border whitespace-nowrap rounded-sm !border-[#F8B400] space-x-2 py-[8px] flex items-center px-[12px] '>
                  <img src={checkedLogo} alt='checkedLogo' />
                  <h4 className='whitespace-nowrap'>Partners</h4>
                </div>
                {step4Partners.map((partner, index) => (
                  <div
                    key={partner}
                    onClick={() => setActive(index + 1)}
                    className={[
                      'bg-[#7683961F] cursor-pointer py-[8px] whitespace-nowrap  space-x-2  flex items-center px-[12px]',
                      index + 1 === active && 'border-2 border-[red]-600',
                    ].join(' ')}
                  >
                    <img src={partnerIcon} alt='partnerIcon' />
                    <h4 className='whitespace-nowrap'>{partner}</h4>
                  </div>
                ))}
              </div>
              <BusinessUploadForm
                index_={active}
                info={step6Info[active]}
                setInfo={setStep6Info}
                data={step6Info}
              />
            </div>
          </div>
        )}

        <div className='flex  justify-center md:w-full   mx-auto'>
          <div className='buttonDiv'>
            <div className='flex justify-between  mt-[40px] mb-7 md:mb-0 items-center md:mt-[105px]'>
              <Button
                className='px-5 !py-[10px] text-[11px] !bg-[#768396] text-white border-[0px] rounded-none '
                size='sm'
                underline={false}
                theme='secondary'
                onClick={() => {
                  setStep((currPage: any) => currPage - 1);
                }}
              >
                PREVIOUS
              </Button>
              <Button
                disabled={isDisabled}
                theme='primary'
                className='px-3 py-[10px] text-[11px] inline-block '
                size='sm'
                underline={false}
                onClick={() => {
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  setStep((currPage: any) => currPage + 1);
                  registerNetcoreActivity(
                    {
                      emailAddress: details?.email,
                      firstName: details?.firstName,
                      lastName: details?.lastName,
                      mobileNumber: details?.phoneNumber,
                    },
                    'TBH_BUSINESS_REGISTRATION_STEP_8',
                  );
                  ReactGA.event({
                    category: 'formSubmit',
                    action: 'TBH_BUSINESS_REGISTRATION_STEP_8',
                    label: 'TBH_BUSINESS_REGISTRATION_STEP_8',
                    // value: 1
                  });
                }}
              >
                SAVE AND CONTINUE
              </Button>
            </div>
          </div>
        </div>
      </form>
      {/* </FormProvider> */}
    </>
  );
};

export default BusinessDocumentUpload;
